import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
  faAlignJustify,
  faAngleLeft,
  faAngleRight,
  faCalendarAlt,
  faEdit,
  faPlus,
  faTimes,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
  catchError,
  finalize,
  forkJoin,
  Observable,
  of,
  retry,
  Subject,
  takeUntil,
  timeout,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateBusinessProcessModel } from '../create/models/businessProcess.model';
import { EntityField } from '../create/models/entity.model';
import { SurveyResponse, SurveyUserResponse } from '../create/models/serveyResponses.model';
import { WorkflowStepAssignedView } from '../create/models/workflowStepAssignedView.model';
import { FilterValues } from '../entity-search/entity-search.component';
import { IncidentParam } from '../incident/incident.component';
import { CardService } from '../shared/components/view/card/card.service';
import { Constants } from '../shared/constants';
import { EntityMaster } from '../shared/models/entityMaster.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateSurvey } from '../shared/components/page/page.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ISearchFilter } from '../shared/models/search-filter.model';
import { IncidentHistoryDialogComponent } from './incident-history-dialog/incident-history-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../shared/services/notifications.service';
import { AgencyModel } from '../shared/models/agency.model';
import { GeneratePdfService } from '../shared/services/generate-pdf-service';
import { QuestionViewModel } from '../shared/models/questionview.model';
import { DownloadAsService } from '../shared/services/downloadAs.service';
import { DisputeService } from '../shared/services/dispute.service';
import { PerformanceArea, TierData } from '../shared/models/performance-measures.model';
import { IDisputeConfig } from '../shared/models/dispute/disputeConfig.model';
import { IDispute } from '../shared/models/dispute/dispute.model';
import {
  MeasureReviewDetailsResponse,
  MeasureDetailsResponse,
} from '../shared/models/dispute/measureReviewDetails.model';
import { AppConstants } from '../shared/appconstants';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-business-process',
  templateUrl: './business-process.component.html',
  styleUrls: ['./business-process.component.scss'],
  standalone: false,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BusinessProcessComponent implements OnInit, OnDestroy {
  faDatePicker = faCalendarAlt;
  exportDisabled: boolean = false;
  selectedEntityId: string;
  filterValues: FilterValues[];
  isFilterPresent: boolean = true;
  form: FormGroup;
  constant: Constants = new Constants();
  appConstants: AppConstants = new AppConstants();
  entities: any;
  entityFields: any;
  entityNameLabel: string;
  filter: {};
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('workflow');
  expandedElement: any;
  displayedColumns: string[] = [];
  fieldData: any;
  size = 5;
  pageIndex = 0;
  wholeData: any = [];
  data: any = [];
  private destroy$ = new Subject<void>();
  dataSource: MatTableDataSource<any>;
  instanceDataSource: MatTableDataSource<any> = new MatTableDataSource([]);

  @ViewChild('instancePaginator') instancePaginator: MatPaginator;
  @ViewChild('instanceSort') instanceSort: MatSort;

  icons = {
    faTimes: faTimes,
    faEdit: faEdit,
  };
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faUserCircle = faUserCircle;
  faAlignJustify = faAlignJustify;
  faPlus = faPlus;
  arrowIconToggle: boolean = false;
  options: FormGroup;
  selectedProcessId: string;
  processes: CreateBusinessProcessModel[] = [];
  selectedProcess: CreateBusinessProcessModel;
  selectedEntity: EntityMaster;
  searchableFields: EntityField[] = [];
  resultFields: EntityField[] = [];
  infoBarFields: EntityField[] = [];
  entityDetailsWithResponses: any;
  entitySearchModel = new entitySearchModel();
  colWidth: any;
  panelOpenState: boolean = false;
  hideCreateIncident: boolean = true;
  currentWFstepId: number;
  isWorkFlowExists: boolean = false;
  userGroupId: string = '';
  totalItems: any;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchData: ISearchFilter[] = [];
  advfilters: ISearchFilter[] = [];
  localProcessId: string = '';
  dashSearchObj: ISearchFilter;
  viewWfDetails: boolean = true;
  openleftpane: boolean = true;
  noAdvFilters: boolean = false;
  userRole: string = '';
  providerType: string = '';
  tierMeasureRequirements: TierData[] = [];
  isReviewCompleted: boolean = false;
  isSurveyExpired: boolean = false;
  surveyDueDate: Date;
  surveyStartDate: Date;
  isSurveyActive: boolean = false;
  isResubmissionAllowed: boolean = false;
  adminUserTypes: string[] = ['organization admin', 'group admin', 'super admin'];
  masterSurveyResults: any;
  consentQuestions: QuestionViewModel[] = [];
  surveyDisputeConfig?: IDisputeConfig | null;
  performanceAreas: PerformanceArea[] = [];
  measureReviewDetails: MeasureReviewDetailsResponse | null = null;
  defaultTier: string = '';

  constructor(
    private baseHttpService: BaseHttpService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private globalsession: GlobalsessionhandlerService,
    private cardService: CardService,
    private spinnerService: NgxSpinnerService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private generatePdfService: GeneratePdfService,
    private downloadService: DownloadAsService,
    private disputeService: DisputeService,
    private storage: StorageService
  ) {}

  searchForm = new FormGroup({
    entityControl: new FormControl(new EntityMaster()),
    search: new FormControl(''),
    dynamicControls: this.fb.group({}),
  });

  filterForm = new FormGroup({
    entityControl: new FormControl(new EntityMaster()),
    search: new FormControl(''),
    dynamicControls: this.fb.group({}),
  });

  ngOnDestroy() {
    try {
      this.storage.remove('DashboardSearchObj');
      this.storage.remove('selectedProcessId');
    } catch (error: any) {
      console.error('[BusinessProcess] ngOnDestroy failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  getColumnHeader(column: string): string {
    try {
      const columnHeaders = {
        wfOverallStatus: 'PBC Submission Status',
        wfDueDate: 'Due Date',
        UserSurveyResponseId: 'PBC Submission ID',
        EditDelete: 'Actions',
        SurveyInstanecId: 'Instance Id',
        CreatedByUserName: 'Created By',
        Icon: '',
        OdpReviewStatus: 'Review Status',
        PbcEvaluationOutcome: 'PBC Evaluation Outcome',
      };

      if (columnHeaders.hasOwnProperty(column)) {
        return columnHeaders[column];
      } else {
        return column;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] getColumnHeader failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return column;
    }
  }

  formatPbcId(value: any): string {
    try {
      if (!value) return '';
      const strValue = value.toString();
      if (strValue.toUpperCase().startsWith('PBC')) {
        return strValue;
      }
      return `PBC${strValue}`;
    } catch (error: any) {
      console.error('[BusinessProcess] formatPbcId failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return '';
    }
  }

  reset() {
    try {
      this.storage.remove('DashboardSearchObj');
      this.searchData.forEach((entry) => (entry.value = ''));
      this.expandedElement = null;
      this.dashSearchObj = null;
      this.instanceDataSource = new MatTableDataSource(this.data);
      this.instanceDataSource.paginator = this.instancePaginator;
    } catch (error: any) {
      console.error('[BusinessProcess] reset failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  onSearchCriteriea(event: any, entry: ISearchFilter) {
    try {
      let type: string = entry.filterType;
      let filterValue = '';
      if (type == 'string') {
        filterValue = event.target.value.toString();
      } else if (type == 'dropdown') {
        filterValue = event.value.toString();
      }
      let foundIndex = this.searchData.findIndex((x) => x.key == entry.key);
      if (foundIndex != -1) {
        this.searchData[foundIndex].value = filterValue;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] onSearchCriteriea failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  search(): any {
    try {
      let filteredData = [...this.data];

      this.searchData.forEach((filter: ISearchFilter) => {
        if (filter.value) {
          switch (filter.filterType) {
            case 'string':
              if (
                filter.displayName == 'Incident Id' ||
                filter.displayName == 'PBC Submission ID' ||
                filter.displayName == 'Provider Legal Entity Name' ||
                filter.displayName == 'Master Provider Index (MPI)' ||
                filter.displayName == 'Contact Last Name' ||
                filter.displayName == 'Contact First Name'
              ) {
                filteredData = this.applyIncidentIdFilter(filteredData, filter);
              } else {
                this.dataSource.filter = filter.value.trim();
                filteredData = filteredData.filter((item) =>
                  item.value[filter.key]?.toString().toLowerCase().includes(filter.value.toLowerCase())
                );
              }
              break;

            case 'dropdown':
              if (filter.displayName == 'Status') {
                filteredData = this.applyStatusFilter(filteredData, filter);
              } else if (filter.displayName == 'Due Date') {
                filteredData = this.applyDueDateFilter(filteredData, filter);
              } else if (filter.displayName == 'Create Date') {
                filteredData = this.applyCreatedDateFilter(filteredData, filter);
              } else {
                filteredData = filteredData.filter((item) =>
                  item.value[filter.key]?.toString().toLowerCase().includes(filter.value.toLowerCase())
                );
              }
              break;

            default:
              break;
          }
        }
      });

      if (this.dashSearchObj != null) {
        filteredData = filteredData.filter(
          (item) => item.value['IsStepAssignedToLoggedInUser']?.toString().toLowerCase() == 'true'
        );
      }

      this.setFilteredData(filteredData);
      return filteredData;
    } catch (error: any) {
      console.error('[BusinessProcess] search failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return [];
    }
  }

  setFilteredData(filteredData: any) {
    try {
      let updatedData =
        filteredData != null && filteredData.length > 0
          ? new MatTableDataSource(filteredData)
          : new MatTableDataSource([]);
      this.instanceDataSource = updatedData;
      setTimeout(() => {
        this.instanceDataSource.paginator = this.instancePaginator;
        this.instanceDataSource.sort = this.instanceSort;
        if (this.instancePaginator) {
          this.instancePaginator.length = filteredData.length;
        }
      }, 300);
    } catch (error: any) {
      console.error('[BusinessProcess] setFilteredData failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  applyStatusFilter(data: any[], searchfield: ISearchFilter): any[] {
    try {
      switch (searchfield.value) {
        case 'In Progress':
          return data.filter(
            (item) => item.value[searchfield.key]?.toString().toLowerCase() == 'in progress'
          );
        case 'Completed':
          return data.filter(
            (item) => item.value[searchfield.key]?.toString().toLowerCase() == 'completed'
          );
        case 'Overdue':
          return data.filter(
            (item) => item.value[searchfield.key]?.toString().toLowerCase() == 'overdue'
          );
        default:
          return data;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] applyStatusFilter failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return data;
    }
  }

  applyIncidentIdFilter(data: any[], searchfield: ISearchFilter): any[] {
    try {
      const searchValue =
        searchfield.key == 'Incident Id' || searchfield.key == 'UserSurveyResponseId'
          ? searchfield.value.replace(/\D/g, '')
          : searchfield.value;

      return data.filter((item) => {
        return item.value[searchfield.key]
          ?.toString()
          .trim()
          .toLowerCase()
          .includes(searchValue?.trim().toLowerCase());
      });
    } catch (error: any) {
      console.error('[BusinessProcess] applyIncidentIdFilter failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return data;
    }
  }

  applyDueDateFilter(data: any[], searchfield: ISearchFilter): any[] {
    try {
      const today = new Date();
      const fifteenDaysFromNow = new Date(today);
      fifteenDaysFromNow.setDate(today.getDate() + 15);
      const thirtyDaysFromNow = new Date(today);
      thirtyDaysFromNow.setDate(today.getDate() + 30);

      return data.filter((item) => {
        if (item.value[searchfield.key] != null) {
          const dueDate = new Date(item.value[searchfield.key]);
          switch (searchfield.value) {
            case 'Due within 15 days':
              return dueDate >= today && dueDate <= fifteenDaysFromNow;
            case 'Due within 30 days':
              return dueDate >= today && dueDate <= thirtyDaysFromNow;
            case 'Others':
              return dueDate > thirtyDaysFromNow;
            case 'Overdue':
              return dueDate < today;
            default:
              return true;
          }
        }
        return false;
      });
    } catch (error: any) {
      console.error('[BusinessProcess] applyDueDateFilter failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return data;
    }
  }

  applyCreatedDateFilter(data: any[], searchfield: ISearchFilter): any[] {
    try {
      const today = new Date();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

      return data.filter((item) => {
        const createdDate = new Date(item.value[searchfield.key]);
        switch (searchfield.value) {
          case 'today':
            return createdDate.toDateString() === today.toDateString();
          case 'this week':
            return createdDate >= startOfWeek && createdDate <= endOfWeek;
          case 'this month':
            return createdDate >= startOfMonth && createdDate <= new Date(today.getFullYear(), today.getMonth() + 1, 0);
          case 'Others':
            return createdDate < startOfMonth;
          default:
            return true;
        }
      });
    } catch (error: any) {
      console.error('[BusinessProcess] applyCreatedDateFilter failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return data;
    }
  }

  setInstanceDataSource(dataList: any) {
    try {
      if (!this.dataSource || this.dataSource.data.length == 0) {
        this.dataSource = new MatTableDataSource(dataList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.dataSource.data = dataList;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] setInstanceDataSource failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  handlePageEvent(event: PageEvent) {
    try {
      this.size = event.pageSize;
      this.pageIndex = event.pageIndex;
      let slicedData = this.data.slice(
        this.pageIndex * this.size,
        this.pageIndex * this.size + this.size
      );
      this.setInstanceDataSource(slicedData);
    } catch (error: any) {
      console.error('[BusinessProcess] handlePageEvent failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  sortInstanceData(sort: Sort) {
    try {
      const data = this.data.slice();
      let sortedData = [];
      if (!sort.active || sort.direction === '') {
        sortedData = data;
        return;
      }
      const activeCol = sort.active;
      const isDateColumn = this.isDateColumn(activeCol);
      const isActionColumn = this.isActionColumn(activeCol);
      sortedData = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        const aValue = a.value[`${activeCol}`];
        const bValue = b.value[`${activeCol}`];

        if (isDateColumn) {
          return this.compareDates(aValue, bValue, isAsc);
        } else if (isActionColumn) {
          return this.compareActions(a, b, isAsc);
        } else {
          return this.compare(aValue, bValue, isAsc);
        }
      });
      this.dataSource.data = sortedData.slice(
        this.pageIndex * this.size,
        this.pageIndex * this.size + this.size
      );
    } catch (error: any) {
      console.error('[BusinessProcess] sortInstanceData failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  sortInstanceDataSource(sort: { active: string; direction: string }) {
    try {
      if (!sort.active || sort.direction === '') {
        this.instanceDataSource.data = [...this.instanceDataSource.data];
        return;
      }

      const isAsc = sort.direction === 'asc';

      this.instanceDataSource.data = this.instanceDataSource.data.slice().sort((a, b) => {
        const aValue = a.value[sort.active];
        const bValue = b.value[sort.active];

        const dateRegex = /^\d{4}-\d{2}-\d{2}/;
        if (
          typeof aValue === 'string' &&
          typeof bValue === 'string' &&
          (dateRegex.test(aValue) || dateRegex.test(bValue))
        ) {
          const aDate = new Date(aValue);
          const bDate = new Date(bValue);
          return (aDate.getTime() - bDate.getTime()) * (isAsc ? 1 : -1);
        }

        if (aValue == null) return isAsc ? -1 : 1;
        if (bValue == null) return isAsc ? 1 : -1;

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return aValue.localeCompare(bValue) * (isAsc ? 1 : -1);
        }

        return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
      });
    } catch (error: any) {
      console.error('[BusinessProcess] sortInstanceDataSource failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  isDateColumn(column: string): boolean {
    try {
      const dateColumns = ['wfDueDate'];
      return dateColumns.includes(column);
    } catch (error: any) {
      console.error('[BusinessProcess] isDateColumn failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return false;
    }
  }

  isActionColumn(column: string): boolean {
    try {
      return column === 'EditDelete';
    } catch (error: any) {
      console.error('[BusinessProcess] isActionColumn failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return false;
    }
  }

  compareDates(a: string, b: string, isAsc: boolean): number {
    try {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return (dateA < dateB ? -1 : 1) * (isAsc ? 1 : -1);
    } catch (error: any) {
      console.error('[BusinessProcess] compareDates failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 0;
    }
  }

  compareActions(a: any, b: any, isAsc: boolean): number {
    try {
      const aStatus = a.value['SurveyStatus'];
      const bStatus = b.value['SurveyStatus'];
      return (aStatus < bStatus ? -1 : 1) * (isAsc ? 1 : -1);
    } catch (error: any) {
      console.error('[BusinessProcess] compareActions failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 0;
    }
  }

  compare(a: any, b: any, isAsc: boolean): number {
    try {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    } catch (error: any) {
      console.error('[BusinessProcess] compare failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 0;
    }
  }

  async ngOnInit() {
    try {
      this.userRole = this.storage.get('LoggedInUserTypeDesc') as string;
      this.providerType = this.storage.get('LoggedInProviderType') as string;
      this.storage.remove('StepNavigated');
      this.spinnerService.show();
      this.userGroupId = this.storage.get('UserGroupId');
      this.localProcessId = this.storage.get('selectedProcessId');
      this.isResubmissionAllowed = false;
      this.isSurveyExpired = true;
      this.isSurveyActive = true;
      this.setInitialData();
      this.destroy$.next();
      this.destroy$.complete();
      this.entitySearchModel.filters = [];
      this.dataSource = new MatTableDataSource([]);
    } catch (error: any) {
      console.error('[BusinessProcess] ngOnInit failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  listProcesses(): Observable<CreateBusinessProcessModel[]> {
    let plist: CreateBusinessProcessModel[] = [];
    let subject = new Subject<CreateBusinessProcessModel[]>();

    try {
      this.baseHttpService.get(this.constant.getBusinessProcessByGroupIdInDataEntry).subscribe({
        next: (response: CreateBusinessProcessModel[]) => {
          plist = response;
          subject.next(plist);
        },
        error: (error: any) => {
          console.error('[BusinessProcess] listProcesses failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          subject.next([]);
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] listProcesses exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      subject.next([]);
    }

    return subject.asObservable();
  }

  setSelectedProcess() {
    try {
      this.processes.forEach(x => (x["isSelected"] = false));
      let selectedId = this.storage.get('selectedProcessId');
      let selectedIdx = -1;
      if (selectedId && selectedId !== 'undefined') {
        selectedIdx = this.processes.findIndex(x => x.businessProcessID == this.localProcessId);
      }
      this.selectedProcess = this.processes[selectedIdx] || this.processes[0];
      this.processes.forEach((p, i) => p["isSelected"] = i === (selectedIdx !== -1 ? selectedIdx : 0));
      this.selectedProcessId = this.selectedProcess.businessProcessID;
      this.storage.set('selectedProcessId', this.selectedProcessId);
      this.globalsession.setBussinessProcessId(this.selectedProcessId);


      this.isWorkFlowExists = !!(this.selectedProcess.surveyModel?.workflowMaster);
      if (this.isWorkFlowExists) {
        this.showCreateInstanceBtnUser(this.selectedProcess.surveyModel.surveyId);
      } else {
        this.hideCreateIncident = false;
      }

      if (this.selectedProcess.surveyModel.displayCalcMeasuresInfo) {
        let agencyId = this.storage.get('LoggedInUserAgencyId');
        if (agencyId) {
          this.loadPerformanceMeasures(agencyId, false);
        } else {
          this.performanceAreas = [];
        }
      } else {
        this.performanceAreas = [];
      }

      this.defaultTier = '';
      if (this.selectedProcess.surveyModel.tierOption) {
        const tierOption = JSON.parse(this.selectedProcess.surveyModel.tierOption);
        this.defaultTier = tierOption.tierName;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] setSelectedProcess failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  setSelectedProcessEntity() {
    try {
      this.isFilterPresent = false;
      this.searchData = [];
      if (this.selectedProcessId != null && this.selectedProcessId.length > 0) {
        this.entities = this.selectedProcess.entityMasters;
        if (this.entities != null && this.entities.length > 0) {
          this.selectedEntity = new EntityMaster();
          this.selectedEntity = this.entities[0];
          this.selectedEntityId = this.entities[0].entityID;

          this.filterEntityFields();
          this.addBasicFilters();
          this.setInitialDashboardFiltersIfAnyOnLoad();
          this.setSurveyInstancesInTable();
          this.setSurveyDueAndStartDate();
        } else {
          this.spinnerService.hide();
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] setSelectedProcessEntity failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  setSurveyDueAndStartDate() {
    try {
      this.baseHttpService
        .getById(this.constant.getSurveyDueAndStartDate, this.selectedProcess.surveyModel.surveyId)
        .subscribe({
          next: (resp) => {
            this.surveyDueDate = resp.dueDate
              ? new Date(resp.dueDate)
              : new Date('9999-12-31T23:59:59');
            this.surveyStartDate = resp.startDate
              ? new Date(resp.startDate)
              : new Date('0001-01-01T00:00:00');
            this.isSurveyActive = this.surveyStartDate && new Date() >= new Date(this.surveyStartDate);
            this.isSurveyExpired = this.surveyDueDate && new Date() > new Date(this.surveyDueDate);
          },
          error: (error: any) => {
            console.error('[BusinessProcess] setSurveyDueAndStartDate failed', {
              message: error?.message,
              innerMessage: error?.error?.message,
              stack: error?.stack,
            });
          },
        });
    } catch (error: any) {
      console.error('[BusinessProcess] setSurveyDueAndStartDate exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  setInitialData() {
    try {
      this.openleftpane = true;
      this.listProcesses().subscribe((result: any[] = []) => {
        this.processes = (result || []).filter(
          (x) => !x.isDeleted && x.status === 'S' && x.surveyModel?.workflowMaster
        );

        if (this.processes.length === 1) {
          this.openleftpane = false;
        }

        if (this.processes.length > 0) {
          this.setSelectedProcess();
          this.setSelectedProcessEntity();
          this.defaultTier = '';
          if (this.selectedProcess.surveyModel.tierOption) {
            const tierOption = JSON.parse(this.selectedProcess.surveyModel.tierOption);
            this.defaultTier = tierOption.tierName;
          }
        } else {
          this.entityNameLabel = 'No Process Present';
          this.processes = [];
          this.spinnerService.hide();
        }
      });
    } catch (error: any) {
      console.error('[BusinessProcess] setInitialData failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  retriveSurveyInstances(): Observable<any> {
    const model = {
      entityId: this.selectedEntityId,
      businessProcessId: this.selectedProcessId,
      pageNumber: this.pageIndex,
      pageSize: this.size,
    };

    let res: any = [];
    let subject = new Subject<any>();

    try {
      this.baseHttpService.post(this.constant.getFieldElementData, model).subscribe({
        next: (apiResponse: any) => {
          res = apiResponse.elementList;
          this.data = res;
          this.isResubmissionAllowed = apiResponse.isResubmissionAllowed;
          subject.next(res);
        },
        error: (error: any) => {
          console.error('[BusinessProcess] retriveSurveyInstances failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.data = [];
          this.isResubmissionAllowed = false;
          subject.next([]);
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] retriveSurveyInstances exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.data = [];
      this.isResubmissionAllowed = false;
      subject.next([]);
    }

    return subject.asObservable();
  }
  // Dynamic derivation of survey response id: we compute when needed from table data.
  // Removed legacy helper getFirstCompletedSurveyResponseId - status filtering no longer required.
  setDisplayedColumns() {  
    this.displayedColumns = [];
    // if (this.isWorkFlowExists) this.displayedColumns.push("Icon");    
    this.displayedColumns.push("UserSurveyResponseId");
    this.displayedColumns.push(...this.resultFields.map(f => f.entityFieldName));
    this.displayedColumns.push("wfOverallStatus", "OdpReviewStatus");
    if (this.providerType !== "SCO") {
      this.displayedColumns.push("Tier Requested", "PbcEvaluationOutcome");
    }
    this.displayedColumns.push("Created On", "EditDelete");
  }

  setSurveyInstancesInTable() {
    try {
      this.setDisplayedColumns();

        this.retriveSurveyInstances().subscribe((data: any) => {
      this.spinnerService.show();
      
      if (data != null && data.length > 0) {
        this.instanceDataSource = new MatTableDataSource(data);
        setTimeout(() => {
          if (this.instancePaginator && this.instanceSort) {
            this.instanceDataSource.paginator = this.instancePaginator;
            this.instanceDataSource.sort = this.instanceSort;
          }
          // Derive default id from grid rows after paginator/sort applied
          this.loadDefaultPerformanceMeasuresFromGrid();
        });
        
        // Load dispute config for the first non-historical incident, then set dispute flags
        const firstNonHistoricalRecord = data.find(record => record?.value?.['IsHistorical'] === false);
        const firstIncidentId = firstNonHistoricalRecord?.value?.['UserSurveyResponseId'];
        if (firstIncidentId != null && firstIncidentId > 0) {
          // Note: getDisputeConfigForSelectedProcess manages its own spinner via finalize
          this.getDisputeConfigForSelectedProcess(firstIncidentId, () => {
            // After dispute config is loaded, set dispute flags in table
            this.setLatestDisputeInTable(data);
            // Load tier requirements after incident ID is available
            this.getTierRequirements(firstIncidentId);
            // Hide the spinner shown at the start of this subscribe block
            this.spinnerService.hide();
          });
        } else {
          this.spinnerService.hide();
        }
      }
      else {
        this.instanceDataSource = new MatTableDataSource([]);
        this.spinnerService.hide();
      }
    });

    } catch (error: any) {
      console.error('[BusinessProcess] setSurveyInstancesInTable failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  private loadDefaultPerformanceMeasuresFromGrid(): void {
    try {
      if (
        !this.instanceDataSource ||
        !Array.isArray(this.instanceDataSource.data) ||
        this.instanceDataSource.data.length === 0
      ) {
        return;
      }

      let foundId: number | null = null;
      for (const row of this.instanceDataSource.data) {
        const raw = row?.value?.['UserSurveyResponseId'];
        if (raw === undefined || raw === null || raw === '') continue;
        const parsed = typeof raw === 'string' ? parseInt(raw, 10) : Number(raw);
        if (!isNaN(parsed) && parsed > 0) {
          foundId = parsed;
          break;
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] loadDefaultPerformanceMeasuresFromGrid failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  async getProcess() {
    try {
      this.openleftpane = true;
      await this.baseHttpService
        .get(this.constant.getBusinessProcessByGroupID)
        .toPromise()
        .then((result) => {
          if (result != null && result.length > 0) {
            this.processes = result.filter(
              (x) =>
                x.isDeleted == false &&
                x.status == 'S' &&
                x.surveyModel != null &&
                x.surveyModel.workflowMaster != null
            );

            if (this.processes.length == 1) {
              this.openleftpane = false;
            }

            if (this.processes.length > 0) {
              this.processes.forEach((x) => {
                x['isSelected'] = false;
              });
              this.selectedProcess = new CreateBusinessProcessModel();
              let selected = this.storage.get('selectedProcessId');
              if (
                selected != null &&
                selected.length > 0 &&
                selected != 'undefined' &&
                selected != undefined
              ) {
                let index = this.processes.findIndex(
                  (x) => x.businessProcessID == this.localProcessId
                );
                if (index != -1) {
                  this.selectedProcess = this.processes[index];
                  this.processes[index]['isSelected'] = true;
                  this.selectedProcessId = this.selectedProcess.businessProcessID;
                }
              } else {
                this.selectedProcess = this.processes[0];
                this.processes[0]['isSelected'] = true;
                this.selectedProcessId = this.selectedProcess.businessProcessID;
              }
              this.storage.set('selectedProcessId', this.selectedProcessId);
              this.globalsession.setBussinessProcessId(this.selectedProcessId);
              this.getEntitieslinkedToProcess();

              this.isWorkFlowExists =
                this.selectedProcess.surveyModel &&
                this.selectedProcess.surveyModel.workflowMaster != null
                  ? true
                  : false;
              if (this.isWorkFlowExists) {
                this.showCreateInstanceBtnUser(this.selectedProcess.surveyModel.surveyId);
              } else {
                this.hideCreateIncident = false;
              }
            } else {
              this.spinnerService.hide();
            }
          } else {
            this.entityNameLabel = 'No Process Present';
            this.processes = [];
            this.spinnerService.hide();
          }
        })
        .catch((error: any) => {
          console.error('[BusinessProcess] getProcess failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.spinnerService.hide();
        });
    } catch (error: any) {
      console.error('[BusinessProcess] getProcess exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  showCreateInstanceBtnUser(surveyId) {
    try {
      this.baseHttpService.getById(this.constant.HasExistingIncident, surveyId).subscribe({
        next: (result: boolean) => {
          this.hideCreateIncident = result['hasInstance'];
        },
        error: (error: any) => {
          console.error('[BusinessProcess] showCreateInstanceBtnUser failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.hideCreateIncident = true;
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] showCreateInstanceBtnUser exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  onClickOfProcessUpdated(index: number) {
    try {
      this.hideCreateIncident = true;
      this.panelOpenState = false;
      this.spinnerService.show();

      this.processes.forEach((x) => (x['isSelected'] = false));
      if (this.processes[index]) {
        this.localProcessId = this.processes[index].businessProcessID;
        this.storage.set('selectedProcessId', this.localProcessId);
      }

      this.setSelectedProcess();
      this.setSelectedProcessEntity();

      if (this.isWorkFlowExists) {
        this.showCreateInstanceBtnUser(this.selectedProcess.surveyModel.surveyId);
      }
    } catch (error: any) {
      console.error('[BusinessProcess] onClickOfProcessUpdated failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  getEntitieslinkedToProcess() {
    try {
      this.isFilterPresent = false;
      this.searchData = [];
      if (this.selectedProcessId != null && this.selectedProcessId.length > 0) {
        this.baseHttpService.getById(this.constant.getProcessEntities, this.selectedProcessId).subscribe({
          next: (result) => {
            if (result != null && result.length > 0) {
              this.entities = result.sort((a: any, b: any) => b.isLookUp - a.isLookUp);
              this.selectedEntityId = this.entities[0].entityID;
              this.searchForm.controls['entityControl'].setValue(this.entities[0].entityID);
              this.filterForm.controls['entityControl'].setValue(this.entities[0].entityID);

              this.selectedEntity = new EntityMaster();
              this.selectedEntity = this.entities[0];
              this.selectedEntityId = this.entities[0].entityID;

              this.filterEntityFields();
              this.addBasicFilters();
              this.setInitialDashboardFiltersIfAnyOnLoad();
              this.getEntityFieldsElementData_Updated();
            } else {
              this.spinnerService.hide();
            }
          },
          error: (error: any) => {
            console.error('[BusinessProcess] getEntitieslinkedToProcess failed', {
              message: error?.message,
              innerMessage: error?.error?.message,
              stack: error?.stack,
            });
            this.spinnerService.hide();
          },
        });
      }
    } catch (error: any) {
      console.error('[BusinessProcess] getEntitieslinkedToProcess exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }
    filterEntityFields() {
    try {
      this.searchableFields = [];
      this.resultFields = [];
      this.infoBarFields = [];
      if (this.selectedEntity != null && this.selectedEntity.entityFields.length > 0) {
        this.selectedEntity.entityFields.forEach((ef) => {
          ef.fieldProperties.forEach((p) => {
            if (p.propertyDetails.propertyName == 'Searchable' && p.propertyValue == '1') {
              let itemFoundSearch = this.resultFields.filter(
                (x) => x.entityFieldID == ef.entityFieldID
              )[0];
              if (itemFoundSearch == null) {
                this.searchableFields.push(ef);
              }

              this.addEntityFieldFilter(ef);
            }
            if (p.propertyDetails.propertyName == 'Display In Results' && p.propertyValue == '1') {
              let itemFound = this.resultFields.filter((x) => x.entityFieldID == ef.entityFieldID)[0];
              if (itemFound == null) {
                this.resultFields.push(ef);
              }
            }
            if (p.propertyDetails.propertyName == 'Display in info-bar' && p.propertyValue == '1') {
              let itemFound = this.infoBarFields.filter((x) => x.entityFieldID == ef.entityFieldID)[0];
              if (itemFound == null) {
                this.infoBarFields.push(ef);
              }
            }
          });
        });
      }

      let advfilters = this.searchData.filter((x) => x.filterCategory == 'Entity');
      if (advfilters == null || advfilters.length == 0) {
        this.noAdvFilters = true;
      }
    } catch (error: any) {
      console.error('[BusinessProcess] filterEntityFields failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  addEntityFieldFilter(ef: EntityField) {
    try {
      let exists = this.searchData.some((item) => item.key === ef.entityFieldName);
      if (!exists) {
        if (
          ef.questionMasters != null &&
          ef.questionMasters.questionOptions != null &&
          ef.questionMasters.questionOptions.length > 0
        ) {
          let efddList: any = ef.questionMasters.questionOptions.map((x) => x.optionText);
          this.searchData.push({
            key: ef.entityFieldName,
            displayName: ef.entityFieldName,
            value: '',
            filterType: 'dropdown',
            dropdownData: efddList,
            filterCategory: 'Entity',
          });
        } else {
          this.searchData.push({
            key: ef.entityFieldName,
            displayName: ef.entityFieldName,
            value: '',
            filterType: 'string',
            filterCategory: 'Entity',
          });
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] addEntityFieldFilter failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  addBasicFilters() {
    try {
      let pbcStatusDDList = ['In Progress', 'Completed'];
      let odpStatusDDList = [
        'Not Started',
        'In Progress',
        'In-Primary Review',
        'In-Peer Review',
        'Documents Needed',
        'Review Completed',
      ];
      this.searchData.push({
        key: 'UserSurveyResponseId',
        displayName: 'PBC Submission ID',
        value: '',
        filterType: 'string',
        filterCategory: 'Basic',
      });
      this.searchData.push({
        key: 'wfOverallStatus',
        displayName: 'PBC Submission Status',
        value: '',
        filterType: 'dropdown',
        dropdownData: pbcStatusDDList,
        filterCategory: 'Basic',
      });
      this.searchData.push({
        key: 'OdpReviewStatus',
        displayName: 'ODP Review Status',
        value: '',
        filterType: 'dropdown',
        dropdownData: odpStatusDDList,
        filterCategory: 'Basic',
      });
    } catch (error: any) {
      console.error('[BusinessProcess] addBasicFilters failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  setInitialDashboardFiltersIfAnyOnLoad() {
    try {
      this.dashSearchObj = JSON.parse(this.storage.get('DashboardSearchObj'));
      if (this.dashSearchObj != null) {
        let ind: number = this.searchData.findIndex((x) => x.key == this.dashSearchObj.key);
        if (ind != -1) {
          this.searchData[ind].value = this.dashSearchObj.value;
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] setInitialDashboardFiltersIfAnyOnLoad failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.dashSearchObj = null;
    }
  }

  async getEntityFieldsElementData_Updated() {
    try {
      this.spinnerService.show();
      let model = new entitySearchModel();
      model.entityId = this.selectedEntityId;
      model.businessProcessId = this.selectedProcessId;
      model.pageNumber = this.pageIndex;
      model.pageSize = this.size;
      this.data = [];
      this.dataSource = new MatTableDataSource([]);

      await this.baseHttpService.post(this.constant.getFieldElementData, model).subscribe({
        next: (result) => {
          if (result.elementList != null && result.elementList.length > 0) {
            this.data = result.elementList;
            this.totalItems = result.pageCount * this.size;
            this.fieldData = result.elementList;
            this.displayedColumns = [];
            this.displayedColumns.push('UserSurveyResponseId');

            this.resultFields.forEach((x) => {
              this.displayedColumns.push(x.entityFieldName);
            });
            this.displayedColumns.push('OdpReviewStatus');
            this.displayedColumns.push('ODP Review Status');
            this.displayedColumns.push('PbcEvaluationOutcome');
            this.displayedColumns.push('Created On');
            this.displayedColumns.push('EditDelete');

            this.data = result.elementList;
            this.wholeData = result.elementList;
            if (this.dashSearchObj != null) {
              this.data = this.search();
            }
            let currentData = this.data.slice(0, this.size);
            this.setInstanceDataSource(currentData);
          } else {
            this.data = [];
            this.dataSource = new MatTableDataSource([]);
          }
          this.spinnerService.hide();
        },
        error: (error: any) => {
          console.error('[BusinessProcess] getEntityFieldsElementData_Updated failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.spinnerService.hide();
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] getEntityFieldsElementData_Updated exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  onSearch(event, field: EntityField) {
    try {
      this.entitySearchModel.entityId = field.entityId;
      if (this.entitySearchModel.filters == undefined || this.entitySearchModel.filters.length == 0) {
        this.entitySearchModel.filters = [];
        if (event.target.value.length > 0) {
          let filt = new SearchFilter();
          filt.key = field.entityFieldName;
          filt.value = event.target.value;
          this.entitySearchModel.filters.push(filt);
        }
      } else if (this.entitySearchModel.filters.length > 0) {
        let itemIndex = this.entitySearchModel.filters.findIndex(
          (x) => x.key == field.entityFieldName
        );
        if (itemIndex != -1) {
          this.entitySearchModel.filters[itemIndex].value = event.target.value;
        } else {
          let filt = new SearchFilter();
          filt.key = field.entityFieldName;
          filt.value = event.target.value;
          this.entitySearchModel.filters.push(filt);
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] onSearch failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  applySearch(event) {
    try {
      let filteredData: any = [];
      if (this.entitySearchModel.filters != undefined && this.entitySearchModel.filters.length > 0) {
        let itemsFoundList: any = [];
        this.fieldData.forEach((dt) => {
          let trueCount: number = 0;
          this.entitySearchModel.filters.forEach((entry) => {
            let ss: string = dt.value[entry.key];
            if (
              ss != undefined &&
              (ss.toLowerCase() === entry.value.toLowerCase() ||
                ss.toLowerCase().includes(entry.value.toString().toLowerCase()))
            ) {
              trueCount++;
            }
          });
          if (trueCount == this.entitySearchModel.filters.length) {
            let index = itemsFoundList.findIndex((x) => x == dt);
            if (index == -1) {
              itemsFoundList.push(dt);
            }
          }
          if (itemsFoundList != null && itemsFoundList.length > 0) {
            filteredData.push(itemsFoundList);
          }
        });
      }

      if (filteredData.length > 0) {
        this.dataSource.data = filteredData[0];
        this.dataSource = new MatTableDataSource(filteredData[0]);
      } else {
        this.dataSource = new MatTableDataSource([]);
      }
    } catch (error: any) {
      console.error('[BusinessProcess] applySearch failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.dataSource = new MatTableDataSource([]);
    }
  }

  resetSearch(event) {
    try {
      event.target.value = '';
      if (this.entitySearchModel.filters.length > 0) {
        this.entitySearchModel.filters = [];
      }
      this.searchableFields.forEach((element) => {
        let a = (<HTMLFormElement>(
          document.getElementById(element.questionMasters.questionId.toString())
        )).value = '';
      });
      this.dataSource = new MatTableDataSource(this.data);
    } catch (error: any) {
      console.error('[BusinessProcess] resetSearch failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  entityChange(event) {
    try {
      this.searchData = [];
      this.selectedEntityId = event.value;
      this.selectedEntity = this.entities.filter((x) => x.entityID == this.selectedEntityId)[0];
      this.filterEntityFields();
      this.addBasicFilters();
      this.getEntityFieldsElementData_Updated();
    } catch (error: any) {
      console.error('[BusinessProcess] entityChange failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  changeArrowIcon() {
    try {
      this.arrowIconToggle = !this.arrowIconToggle;
    } catch (error: any) {
      console.error('[BusinessProcess] changeArrowIcon failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  paginate(event: any) {
    try {
      if (event == 0) {
        event = 1;
      }
      this.pageIndex = event;
      this.getEntityFieldsElementData_Updated();
    } catch (error: any) {
      console.error('[BusinessProcess] paginate failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  public getStatusColor(stepStatus, disableClick: boolean, isOverdue: boolean): string {
    try {
      if (stepStatus == 'Completed') {
        return 'green';
      }
      if (stepStatus == 'In Progress') {
        if (isOverdue) {
          return 'red';
        } else {
          return 'yellow';
        }
      }
      if (stepStatus == 'Not Started') {
        if (isOverdue) {
          return 'red';
        } else {
          if (disableClick) {
            return 'black';
          } else {
            return 'yellow';
          }
        }
      }
      return 'black';
    } catch (error: any) {
      console.error('[BusinessProcess] getStatusColor failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 'black';
    }
  }

  filterOpen(event) {
    try {
      this.panelOpenState = true;
      this.filterEntityFields();
    } catch (error: any) {
      console.error('[BusinessProcess] filterOpen failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  async CreateNewIncident() {
    try {
      let HasExistingSurveyInstance = await this.hasExistingInstance();

      if (HasExistingSurveyInstance) {
        this.notificationService.showError(
          'You already have an existing annual submission. Please view the existing submission.',
          'Warning'
        );
        return;
      }

      let hasAgencyDetails = await this.hasAgencyDetails();
      if (hasAgencyDetails == null) {
        this.notificationService.showError(
          'Agency details not found. Please contact your administrator.',
          'Error'
        );
        return;
      }

      this.globalsession.setBussinessProcessId(this.selectedProcessId);
      this.globalsession.setSurveyInstanceId('');
      this.cardService.getProcessdetails(this.selectedProcess);
      this.globalsession.setSurveyId(this.selectedProcess.surveyModel.surveyId);
      this.GeSurveyWorkFlowDetails(this.selectedProcess.surveyModel.surveyId);
      this.getWfStepsToDisplayInIncidentPage('OnLoad');
    } catch (error: any) {
      console.error('[BusinessProcess] CreateNewIncident failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.notificationService.showError('Unable to create submission.', 'Error');
    }
  }

  existingIncident(selectedSurveyInstanceId, element, step?: any, icon?: string, action?: string) {
    try {
      if (step != null) {
        this.globalsession.setNavigatedStep(step);
        this.storage.set('StepNavigated', JSON.stringify(step));
      }

      if (
        action != null &&
        action.length > 0 &&
        (action == 'raiseDispute' || action == 'editDispute' || action == 'viewDispute')
      ) {
        this.globalsession.setRaiseDisputeFlag(true);
        const entryLatestDispute = element.value['latestDispute'];
        const incidentId = element.value['UserSurveyResponseId'];

        if (action == 'raiseDispute') {
          this.globalsession.setDispute(null);
        } else if ((action == 'editDispute' || action == 'viewDispute') && entryLatestDispute != null) {
          this.globalsession.setDispute(entryLatestDispute);
        }

        if (incidentId != null && incidentId > 0) {
          this.getDisputeConfigForSelectedProcess(incidentId);
        }

        this.callGetMeasureReviewDetails(selectedSurveyInstanceId, element);
      } else {
        this.globalsession.setRaiseDisputeFlag(false);
      }

      if (icon != null && icon.length > 0 && icon == 'view') {
        this.globalsession.setViewIconFlag(true);
      } else {
        this.globalsession.setViewIconFlag(false);
      }
      this.globalsession.setSurveyInstanceId(selectedSurveyInstanceId);
      let grpId = this.storage.get('UserGroupId');
      this.cardService.getProcessdetails(this.selectedProcess);

      if (this.infoBarFields.length > 0) {
        let elementCopy = element;
        let keyslist = Object.keys(element.value);
        let fieldNameList: string[] = [];
        this.infoBarFields.forEach((x) => fieldNameList.push(x.entityFieldName));
        keyslist.forEach((x) => {
          if (!fieldNameList.includes(x)) {
            delete elementCopy.value[x];
          }
        });
        this.cardService.getDisplayInfoBarDetails(elementCopy);
      }

      this.ResumeViewSurvey(this.selectedProcess.surveyModel.surveyId, grpId, selectedSurveyInstanceId);
    } catch (error: any) {
      console.error('[BusinessProcess] existingIncident failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.notificationService.showError('Unable to open submission.', 'Error');
    }
  }

  private callGetMeasureReviewDetails(selectedSurveyInstanceId: string, element: any): void {
    try {
      const incidentId = element.value['UserSurveyResponseId'];

      if (!incidentId || incidentId <= 0) {
        console.log('Invalid incident ID for measure review details');
        return;
      }

      this.baseHttpService
        .getById(this.constant.getMeasureReviewDetails, incidentId.toString())
        .pipe(
          catchError((err) => {
            console.error('Failed to load measure review details:', err);
            return of(null);
          })
        )
        .subscribe({
          next: (response: MeasureReviewDetailsResponse) => {
            if (response != null) {
              console.log('Measure review details loaded:', response);
              this.measureReviewDetails = response;
            }
          },
          error: (error) => {
            console.error('Error processing measure review details:', error);
          },
        });
    } catch (error: any) {
      console.error('[BusinessProcess] callGetMeasureReviewDetails failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  private processCombinedDisputeData(surveyData: CreateSurvey): void {
    try {
      if (!this.measureReviewDetails || !surveyData) {
        console.warn('Missing data for dispute processing');
        return;
      }

      if (!this.measureReviewDetails.measureDetails || !Array.isArray(this.measureReviewDetails.measureDetails)) {
        console.warn('Measure details not available');
        return;
      }

      const measureMap = new Map<string, any>();
      this.measureReviewDetails.measureDetails.forEach((measure) => {
        measureMap.set(measure.identifier.toLowerCase().trim(), {
          isMet: measure.isMet,
          reviewReasons: measure.reviewReasons,
          questionIds: measure.questionIds,
          calculationResultInfo: measure.calculationResultInfo,
        });
      });

      const mappedMeasureReviewDetailsDict: Record<number, any> = {};

      surveyData.sections?.forEach((section) => {
        section.questions
          ?.filter(
            (question) =>
              question.inputType === 'displaytext' &&
              question.questionAttributes &&
              Array.isArray(question.questionAttributes) &&
              question.questionAttributes.length > 0
          )
          .forEach((question) => {
            const mappedMeasures = question.questionAttributes
              .map((attr) => {
                const normalizedAttr =
                  attr.attributeName.toLowerCase().trim() === surveyData.mappingKey.toLowerCase().trim()
                    ? attr.attributeValue.toLowerCase().trim()
                    : null;
                return normalizedAttr ? measureMap.get(normalizedAttr) : null;
              })
              .filter((measure) => measure != null);

            if (mappedMeasures.length > 0) {
              mappedMeasureReviewDetailsDict[question.questionId] = {
                sectionId: section.sectionId,
                measures: mappedMeasures.map((m: MeasureDetailsResponse) => ({
                  isMet: m.isMet,
                  reviewReasons: m.reviewReasons?.flatMap((rg: any) => rg.reasons ?? []) ?? [],
                  calculationResultInfo: m.calculationResultInfo,
                  questionIds: m.questionIds,
                })),
              };
            }
          });
      });

      this.globalsession.setMappedMeasureReviewDetails(mappedMeasureReviewDetailsDict);
    } catch (error: any) {
      console.error('[BusinessProcess] processCombinedDisputeData failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  private alphaNumericSort(a: string, b: string) {
    try {
      if (a == null) return -1;
      if (b == null) return 1;
      return a.localeCompare(b, 'en', { numeric: true });
    } catch (error: any) {
      console.error('[BusinessProcess] alphaNumericSort failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 0;
    }
  }

  private getTierRequirements(incidentId: string) {
    try {
      if (!this.providerType) {
        return;
      }
      this.baseHttpService.get(`${this.constant.getMeasureRequirements}/${this.providerType}/${incidentId}`).subscribe({
        next: (groups: TierData[]) => {
        this.tierMeasureRequirements = groups || [];
        this.isReviewCompleted = this.tierMeasureRequirements.some(g =>
          (g.measures || []).some(m => m.isReviewCompleted === true)
        );
      },
        error: (err) => {
          console.error('[BusinessProcess] Measure requirements fetch error', err);
          this.tierMeasureRequirements = [];
          this.isReviewCompleted = false;
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] getTierRequirements failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.tierMeasureRequirements = [];
      this.isReviewCompleted = false;
    }
  }

  private loadPerformanceMeasures(id: any, isResponseId: boolean): void {
    try {
      if (!id) {
        this.performanceAreas = [];
        return;
      }

      let url = isResponseId
        ? `${this.constant.httpBaseUrl}${this.constant.getPerformanceMeasures}/${id}`
        : `${this.constant.httpBaseUrl}${this.constant.getPerformanceMeasuresByAgencyId}/${id}`;

      this.baseHttpService.get(url).subscribe({
        next: (areas: PerformanceArea[]) => {
          if (areas != null && areas.length > 0) {
            areas.sort((a, b) =>
              this.alphaNumericSort(
                a.performanceAreaTitle,
                b.performanceAreaTitle
              )
            );

            areas.forEach((area) => {
              area.expanded = true;

              if (area.measures != null && area.measures.length > 0) {
                area.measures.sort((a, b) =>
                  this.alphaNumericSort(
                    a.measureTitle,
                    b.measureTitle
                  )
                );

                area.measures.forEach((measure) => {
                  measure.expanded = true;
                });
              }
            });
          }

          this.performanceAreas = areas || [];
        },
        error: (err) => {
          console.error(
            '[BusinessProcess] Performance measures fetch error',
            err
          );
          this.performanceAreas = [];
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] loadPerformanceMeasures failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });

      this.performanceAreas = [];
    }
  }

  GeSurveyWorkFlowDetails(surveyId: string) {
    try {
      this.spinnerService.show();
      const survey$ = this.baseHttpService.getById(this.constant.getSurveyData, surveyId);
      const bpwfDetails$ = this.baseHttpService.getById(
        this.constant.getIncidentWorkFlowDeatils,
        this.selectedProcessId
      );

      forkJoin([survey$, bpwfDetails$]).subscribe({
        next: (result) => {
          if (result != null) {
            this.cardService.getSurveyDetails(result[0]);
            this.cardService.getProcessWorkflowDetails(result[1]);
            this.spinnerService.hide();
            this.storage.set('surveyResponsePageFlag', 'false');
            this.router.navigate(['/incidentReport']);
          }
        },
        error: (error: any) => {
          console.error('[BusinessProcess] GeSurveyWorkFlowDetails failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.spinnerService.hide();
          this.notificationService.showError('Unable to load workflow details', 'Error');
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] GeSurveyWorkFlowDetails exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  ResumeViewSurvey(surveyId: string, groupId: string, selectedSurveyInstanceId: string) {
    this.spinnerService.show();

    const survey$ = this.baseHttpService.getById(this.constant.getSurveyById, surveyId).pipe(
      timeout(30000),
      retry(2),
      catchError((err) => {
        console.error('Survey fetch failed:', err);
        return of(null);
      })
    );

    const surveyResponse$ = this.baseHttpService
      .get(
        this.constant.getProcessIncidentResponses +
          '/' +
          surveyId +
          '/' +
          false +
          '/' +
          selectedSurveyInstanceId
      )
      .pipe(
        timeout(30000),
        retry(2),
        catchError((err) => {
          console.error('Survey response fetch failed:', err);
          return of(null);
        })
      );

    const bpwfDetails$ = this.baseHttpService
      .getById(this.constant.getIncidentWorkFlowDeatils, this.selectedProcessId)
      .pipe(
        timeout(30000),
        retry(2),
        catchError((err) => {
          console.error('BP workflow details fetch failed:', err);
          return of(null);
        })
      );

    const wfStepAccess$ = this.baseHttpService
      .getById(this.constant.getWfStepAccessibleBySurveyId, surveyId)
      .pipe(
        timeout(30000),
        retry(2),
        catchError((err) => {
          console.error('WF step access fetch failed:', err);
          return of(null);
        })
      );

    let param = new IncidentParam();
    param.bussinessProcessId = this.selectedProcessId;
    param.SurveyInstanceId = selectedSurveyInstanceId;
    param.UserSurveyResponseId = 0;

    const wfStepsToDisplay$ = this.baseHttpService
      .post(this.constant.getProcessWFStepAssignedNew, param)
      .pipe(
        timeout(30000),
        retry(2),
        catchError((err) => {
          console.error('WF steps to display fetch failed:', err);
          return of(null);
        })
      );

    forkJoin([survey$, surveyResponse$, bpwfDetails$, wfStepAccess$, wfStepsToDisplay$])
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.spinnerService.hide())
      )
      .subscribe({
        next: (results) => {
          if (results != null && results.some((result) => result != null)) {
            this.cardService.getSurveyDetails(new CreateSurvey());

            if (results[0] != null) {
              this.cardService.getSurveyDetails(results[0]);
            }

            this.globalsession.setSurvey(<CreateSurvey>{});
            let response = new SurveyUserResponse();

            if (results[1] != null && results[1].userResponses) {
              response = results[1].userResponses.filter(
                (x) => x.surveyInstanceId == selectedSurveyInstanceId
              )[0];
              if (response != null) {
                this.globalsession.setSurveyInstanceId(response.surveyInstanceId);

                let agencyDet = new AgencyModel();
                agencyDet.agencyId = response.agencyId;
                agencyDet.agencyName = response.agencyName;
                this.cardService.tempHoldAgencyDetails(agencyDet);
                this.cardService.getUserResponseSurvey(response);
              }
            }

            if (results[2] != null) {
              this.cardService.getProcessWorkflowDetails(results[2]);
            }

            if (results[4] != null) {
              let wfStepsData = results[4] as WorkflowStepAssignedView[];
              wfStepsData = wfStepsData.filter((x) => x.stepStatus == 'CP' || x.isAssigned == true);

              let pendingStep = wfStepsData.filter(
                (x) => x.stepStatus == 'NE' || x.stepStatus == 'PE'
              );
              if (pendingStep != null && pendingStep.length > 0) {
                this.globalsession.setNavigatedStep(pendingStep);
                this.storage.set('StepNavigated', JSON.stringify(pendingStep));
              }

              this.cardService.tempHoldWFAssignmentDetail(wfStepsData);
            }

            this.storage.set('surveyResponsePageFlag', 'false');
            this.processCombinedDisputeData(results[0]);
            this.router.navigate(['/incidentReport']);
          } else {
            this.notificationService.showError('Failed to load survey data', 'Error');
            this.router.navigate(['/incidentReport']);
          }
        },
        error: (error) => {
          console.error('ForkJoin error in ResumeViewSurvey:', error);
          this.notificationService.showError('An error occurred while loading survey', 'Error');
          this.router.navigate(['/incidentReport']);
        },
      });
  }

  async workflowTitles(value, element) {
    try {
      if (element.value.ExpandWFDetails == null) {
        if (value) {
          this.spinnerService.show();
          let model = {
            userSurveyRespoonseId: value,
            businessProcessID: this.selectedProcessId,
          };
          this.baseHttpService.post(this.constant.getWFStatusReport, model).subscribe({
            next: (result) => {
              this.instanceDataSource.data.forEach((val) => {
                if (val.label == element.label) {
                  val.value.ExpandWFDetails = result;
                }
              });
              this.spinnerService.hide();
            },
            error: (error: any) => {
              console.error('[BusinessProcess] workflowTitles failed', {
                message: error?.message,
                innerMessage: error?.error?.message,
                stack: error?.stack,
              });
              this.spinnerService.hide();
            },
          });
        }
      }
    } catch (error: any) {
      console.error('[BusinessProcess] workflowTitles exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  public getStatusColor_NEW(
    stepStatus,
    disableClick: boolean,
    isOverdue: boolean,
    totSteps,
    currStepIndex: number
  ): string {
    try {
      if (stepStatus == 'Completed') {
        return 'green';
      } else if (stepStatus == 'In Progress') {
        if (isOverdue) {
          return 'red';
        } else if (totSteps[currStepIndex].isAssigned != null && totSteps[currStepIndex].isAssigned == true) {
          return 'yellow';
        } else {
          return 'black';
        }
      } else if (stepStatus == 'Not Started' || stepStatus == 'NE') {
        if (isOverdue) {
          return 'red';
        } else {
          if (disableClick || (totSteps[currStepIndex - 1] != null && totSteps[currStepIndex - 1].stepStatus != 'CP')) {
            return 'black';
          } else {
            return 'yellow';
          }
        }
      }
      return 'black';
    } catch (error: any) {
      console.error('[BusinessProcess] getStatusColor_NEW failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return 'black';
    }
  }

  hasExistingInstance(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const hasInstanceEndPoint = `${this.constant.HasExistingIncident}/${this.selectedProcess.surveyModel.surveyId}`;
        this.baseHttpService.get(hasInstanceEndPoint).subscribe(
          (result) => {
            if (result != null) {
              resolve(result.hasInstance);
            } else {
              console.log('unable to fetch the existing instance information');
              resolve(false);
            }
          },
          (error) => {
            console.error('API error in hasExistingInstance:', error);
            resolve(false);
          }
        );
      } catch (error: any) {
        console.error('[BusinessProcess] hasExistingInstance failed', {
          message: error?.message,
          innerMessage: error?.error?.message,
          stack: error?.stack,
        });
        resolve(false);
      }
    });
  }

  hasAgencyDetails(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        this.baseHttpService.get(this.constant.getUserAgencyDetails).subscribe(
          (result) => {
            if (result != null && result.agencyId != null && result.agencyId.length > 0) {
              this.cardService.tempHoldAgencyDetails(result);
              resolve(result);
            } else {
              resolve(null);
            }
          },
          (error) => {
            console.error('API error in hasAgencyDetails:', error);
            resolve(null);
          }
        );
      } catch (error: any) {
        console.error('[BusinessProcess] hasAgencyDetails failed', {
          message: error?.message,
          innerMessage: error?.error?.message,
          stack: error?.stack,
        });
        resolve(null);
      }
    });
  }

  getWfStepsToDisplayInIncidentPage(
    action: string,
    selectedSurveyInstanceId?: string,
    UserSurveyResponseId?: any,
    icon?: string
  ) {
    try {
      let param = new IncidentParam();
      param.bussinessProcessId = this.selectedProcessId;
      if (action == 'OnLoad') {
        param.SurveyInstanceId = '';
        param.UserSurveyResponseId = 0;
      } else if (action == 'OnEdit') {
        if (selectedSurveyInstanceId.length > 0) {
          param.SurveyInstanceId = selectedSurveyInstanceId;
        }
        if (UserSurveyResponseId > 0) {
          param.UserSurveyResponseId = UserSurveyResponseId;
        }
      }
      this.baseHttpService.post(this.constant.getProcessWFStepAssignedNew, param).subscribe({
        next: (data: WorkflowStepAssignedView[]) => {
          if (icon != null && icon.length > 0 && icon == 'view') {
            data = data.filter((x) => x.stepStatus != 'NE');
          } else {
            data = data.filter((x) => x.stepStatus == 'CP' || x.isAssigned == true);
          }

          let pendingStep = data.filter((x) => x.stepStatus == 'NE' || x.stepStatus == 'PE');
          if (pendingStep != null) {
            this.globalsession.setNavigatedStep(pendingStep);
            this.storage.set('StepNavigated', JSON.stringify(pendingStep));
          }

          this.cardService.tempHoldWFAssignmentDetail(data);
        },
        error: (error: any) => {
          console.error('[BusinessProcess] getWfStepsToDisplayInIncidentPage failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] getWfStepsToDisplayInIncidentPage exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  openIncidentHistory(incidentlogs: any) {
    try {
      this.viewWfDetails = false;
      const dialogRef = this.dialog.open(IncidentHistoryDialogComponent, {
        width: '700px',
        height: '500px',
        data: { logdata: incidentlogs },
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log('The dialog was closed');
      });
    } catch (error: any) {
      console.error('[BusinessProcess] openIncidentHistory failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }

  onDownload(element: any, downloadType: string) {
    try {
      this.spinnerService.show();
      let surveyId: string = this.selectedProcess.surveyModel.surveyId;
      let incidentId: string = element.value['UserSurveyResponseId'];
      if (Number(incidentId) == null || Number(incidentId) <= 0) {
        this.notificationService.showError('Invalid Incident Id', 'Error');
        this.spinnerService.hide();
        return;
      }

      if (downloadType === 'allattachments') {
        const mpiId = element.value['Master Provider Index (MPI)'] || '';
        this.downloadAllAttachmentsAsZip(surveyId, Number(incidentId), mpiId);
        return;
      }

      this.downloadService.downloadFile(surveyId, downloadType, [Number(incidentId)]).subscribe({
        next: (success: boolean) => {
          if (success) {
            this.notificationService.showSuccess('Download completed successfully', 'Success!');
          } else {
            this.notificationService.showError('Download failed', 'Error!');
          }
          this.spinnerService.hide();
        },
        error: (error: any) => {
          console.error('[BusinessProcess] onDownload failed', {
            message: error?.message,
            innerMessage: error?.error?.message,
            stack: error?.stack,
          });
          this.notificationService.showError('Download failed', 'Error!');
          this.spinnerService.hide();
        },
      });
    } catch (error: any) {
      console.error('[BusinessProcess] onDownload exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  downloadAllAttachmentsAsZip(surveyId: string, surveyResponseId: number, mpiId: string): void {
    try {
      const requestPayload = {
        surveyId: surveyId,
        surveyResponseId: surveyResponseId,
        contentType: 'application/zip',
      };

      this.baseHttpService
        .post(this.constant.downloadFileAttachmentsAsZip, requestPayload, {
          responseType: 'blob',
          observe: 'response',
        })
        .subscribe({
          next: (response: any) => {
            let fileName = mpiId
              ? `Attachments_${mpiId}_${surveyResponseId}.zip`
              : `Attachments_${surveyResponseId}.zip`;

            const blob = new Blob([response.body], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            this.notificationService.showSuccess('Attachments downloaded successfully', 'Success!');
            this.spinnerService.hide();
          },
          error: (error) => {
            console.error('Error downloading attachments:', error);
            this.notificationService.showError('Failed to download attachments', 'Error!');
            this.spinnerService.hide();
          },
        });
    } catch (error: any) {
      console.error('[BusinessProcess] downloadAllAttachmentsAsZip exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  onResolutionDownload(element: any, downloadType: string) {
    try {
      this.spinnerService.show();
      let surveyId: string = this.selectedProcess.surveyModel.surveyId;
      let incidentId: string = element.value['UserSurveyResponseId'];
      if (Number(incidentId) == null || Number(incidentId) <= 0) {
        this.notificationService.showError('Invalid Incident Id', 'Error');
        this.spinnerService.hide();
        return;
      }

      const latestDispute = element.value && element.value['latestDispute'];
      const hasDispute = latestDispute != null && latestDispute.disputeId > 0;
      const mpiId = element.value['Master Provider Index (MPI)'] || '';

      if (downloadType === 'allattachments' && hasDispute) {
        this.downloadDisputeAttachmentsAsZip(surveyId, Number(incidentId), latestDispute.disputeId, mpiId);
        return;
      }

      if (downloadType === 'excel' && hasDispute) {
        const items = [{ incidentId: Number(incidentId), disputeId: latestDispute.disputeId }];
        this.downloadService.downloadDisputeFilesCombined(surveyId, items).subscribe({
          next: (success: boolean) => {
            if (success) {
              this.notificationService.showSuccess('Resolution response downloaded successfully', 'Success!');
            } else {
              this.notificationService.showError('Failed to download resolution response', 'Error!');
            }
            this.spinnerService.hide();
          },
          error: (error: any) => {
            console.error('[BusinessProcess] onResolutionDownload failed', {
              message: error?.message,
              innerMessage: error?.error?.message,
              stack: error?.stack,
            });
            this.notificationService.showError('Failed to download resolution response', 'Error!');
            this.spinnerService.hide();
          },
        });
        return;
      }

      this.spinnerService.hide();
    } catch (error: any) {
      console.error('[BusinessProcess] onResolutionDownload exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  downloadDisputeAttachmentsAsZip(
    surveyId: string,
    surveyResponseId: number,
    disputeId: number,
    mpiId: string
  ): void {
    try {
      const requestPayload = {
        surveyId: surveyId,
        surveyResponseId: surveyResponseId,
        disputeId: disputeId,
        contentType: 'application/zip',
      };

      this.baseHttpService
        .post(this.constant.downloadDisputeAttachmentsAsZip, requestPayload, {
          responseType: 'blob',
          observe: 'response',
        })
        .subscribe({
          next: (response: any) => {
            const fileName = mpiId
              ? `Resolution_Attachments_${mpiId}_${surveyResponseId}_${disputeId}.zip`
              : `Resolution_Attachments_${surveyResponseId}_${disputeId}.zip`;

            const blob = new Blob([response.body], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            this.notificationService.showSuccess('Resolution attachments downloaded successfully', 'Success!');
            this.spinnerService.hide();
          },
          error: (error: any) => {
            console.error('[BusinessProcess] downloadDisputeAttachmentsAsZip failed', {
              message: error?.message,
              innerMessage: error?.error?.message,
              stack: error?.stack,
            });
            this.notificationService.showError('Failed to download resolution attachments', 'Error!');
            this.spinnerService.hide();
          },
        });
    } catch (error: any) {
      console.error('[BusinessProcess] downloadDisputeAttachmentsAsZip exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      this.spinnerService.hide();
    }
  }

  getDisputeConfigForSelectedProcess(incidentId?: number, onComplete?: () => void) {
    try {
      if (!incidentId || incidentId <= 0) {
        if (onComplete) {
          onComplete();
        }
        return;
      }

      if (this.selectedProcess && this.selectedProcess.surveyModel && this.selectedProcess.surveyModel.surveyId) {
        this.surveyDisputeConfig = null;
        this.spinnerService.show();
        this.disputeService
          .getSurveyDisputeConfig(this.selectedProcess.surveyModel.surveyId, incidentId)
          .pipe(finalize(() => this.spinnerService.hide()))
          .subscribe({
            next: (res) => {
              if (res) {
                this.surveyDisputeConfig = {} as IDisputeConfig;
                this.surveyDisputeConfig = res;
                this.globalsession.setSurveyDisputeConfig(this.surveyDisputeConfig);
              } else {
                this.globalsession.setSurveyDisputeConfig(null);
              }
              if (onComplete) {
                onComplete();
              }
            },
            error: (error: any) => {
              console.error('[BusinessProcess] getDisputeConfigForSelectedProcess failed', {
                message: error?.message,
                innerMessage: error?.error?.message,
                stack: error?.stack,
              });
              this.globalsession.setSurveyDisputeConfig(null);
              if (onComplete) {
                onComplete();
              }
            },
          });
      } else if (onComplete) {
        onComplete();
      }
    } catch (error: any) {
      console.error('[BusinessProcess] getDisputeConfigForSelectedProcess exception', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      if (onComplete) {
        onComplete();
      }
    }
  }

  setLatestDisputeInTable(tblData: any) {
    try {
      tblData.forEach((entry) => {
        if (entry.value != null && entry.value['DisputesList'] != null && entry.value['DisputesList'].length > 0) {
          const entryDisputes = entry.value['DisputesList'];
          const entryLatestDispute = entryDisputes[0];
          entry.value['latestDispute'] = entryLatestDispute;
          entry.value['showRaiseDisputeBtn'] =
            this.canRaiseDisputeForEntry(entryDisputes) &&
            entryLatestDispute.status.trim().toLowerCase() ==
              this.appConstants.disputeStatus.RAISED.trim().toLowerCase();
        } else {
          entry.value['latestDispute'] = null;
          entry.value['showRaiseDisputeBtn'] = this.canRaiseDisputeForEntry([]);
        }
        entry.value['isActiveDispute'] = this.disputeService.isActiveDispute(this.surveyDisputeConfig);
      });
    } catch (error: any) {
      console.error('[BusinessProcess] setLatestDisputeInTable failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
    }
  }
  canRaiseDisputeForEntry(entryDisputes: IDispute[]): boolean {
    try {
      return this.disputeService.canRaiseDisputeForIncident(this.surveyDisputeConfig, entryDisputes);
    } catch (error: any) {
      console.error('[BusinessProcess] canRaiseDisputeForEntry failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return false;
    }
  }

  isAdminUser(): boolean {
    try {
      if (!this.userRole) {
        return false;
      }
      return this.adminUserTypes.some((adminRole) =>
        this.userRole.toLowerCase().includes(adminRole.toLowerCase())
      );
    } catch (error: any) {
      console.error('[BusinessProcess] isAdminUser failed', {
        message: error?.message,
        innerMessage: error?.error?.message,
        stack: error?.stack,
      });
      return false;
    }
  }
}

export class entitySearchModel {
  entityId: string;
  businessProcessId: string;
  filters: SearchFilter[];
  pageNumber: number;
  pageSize: number;
  elementList: any[];
  pageCount: number;
}

export class SearchFilter {
  key: string;
  value: string;
}
